import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    pageDropdown: [10, 100, 1000],
    perPage: 10,
    planType: 1,
    accessLevel: null,
    entitiyId: null,
    allowedSubTabsMap: {}, // { ZN: [{ to: 'zones', title: 'Zonas' }, ...], BM: [...], ... }

    // Infraction filters state
    infractionFilters: {
      estadoFilter: '',
      tipoFilter: null,
      infractionDateFilter: '',
      autoDateFilter: {},
      autoEstadoFilter: {},
      tipoFilterData: {},
      ansrFilterData:{},
      ansrFilter: null
    },

    platformId: null,
    allowedPlatforms: ['acesso', 'mobility'],

    // auth mock state (since you had getters for this in Vuex)
    auth: {
      loggedIn: false,
      user: null
    },

    // Flags de sessão dupla (API 1 = Strapi, API 2 = Legada)
    hasSession1: false, // Strapi
    hasSession2: false, // API Legada

    // Tema da entidade (carregado no login via /api/entity/theme)
    theme: null,
  }),

  getters: {
    isAuthenticated: (state) => state.auth.loggedIn,
    loggedInUser: (state) => state.auth.user,
    getAccessLevel: (state) => state.accessLevel,
    getEntityId: (state) => state.entitiyId,
    getPlatformId: (state) => state.platformId,
    // Verifica se pelo menos uma sessão está ativa
    hasAnySession: (state) => state.hasSession1 || state.hasSession2,
    // Verifica se ambas as sessões estão ativas
    hasBothSessions: (state) => state.hasSession1 && state.hasSession2,
  },

  actions: {
    // Infraction filters
    setInfractionFilter(filterType, value) {
      this.infractionFilters[filterType] = value
    },
    resetInfractionFilters() {
      this.infractionFilters = {
        estadoFilter: '',
        tipoFilter: null,
        infractionDateFilter: '12/12/12',
        autoDateFilter: {},
        autoEstadoFilter: {},
        tipoFilterData: {}
      }
    },

    initPlatform() {
      const saved = localStorage.getItem('platformId')

      // if exists & valid
      if (saved && this.allowedPlatforms.includes(saved)) {
        this.platformId = saved
      } else {
        // fallback
        this.platformId = 'acesso'
        localStorage.setItem('platformId', 'acesso')
      }
    },

    // Platform Id
   setPlatform(value) {
      if (this.allowedPlatforms.includes(value)) {
        this.platformId = value
        localStorage.setItem('platformId', value)
      } else {
        console.warn(`Invalid platform: ${value}`)
      }
    },

    // Per page setter
    setPerPage(value) {
      this.perPage = value
    },

    // Access level setter
    setAccessLevel(level) {
      this.accessLevel = level
    },

    // Entity Id setter
    setEntityId(id) {
      this.entitiyId = id
    },

    // Allowed sub-tabs per settings tab (e.g. ZN, BM)
    setAllowedSubTabsMap(map) {
      this.allowedSubTabsMap = map
    },

    // Setters de sessão dupla
    setSession1(value) {
      this.hasSession1 = !!value
    },
    setSession2(value) {
      this.hasSession2 = !!value
    },
    clearSessions() {
      this.hasSession1 = false
      this.hasSession2 = false
    },

    setTheme(theme) {
      this.theme = theme
      if (process.client) {
        localStorage.setItem('entity_theme', JSON.stringify(theme))
      }
    },
    loadTheme() {
      if (process.client) {
        const saved = localStorage.getItem('entity_theme')
        if (saved) {
          try { this.theme = JSON.parse(saved) } catch {}
        }
      }
    },
       resetFormFields(fields) {
      return fields.map(field => ({
        ...field,
        value:
          field.type === 'multi-select' || field.type === 'date'
            ? null
            : field.type === 'text' || field.type === 'email' || field.type === 'textarea'
              ? ''
              : [],
      }));
    }
  }
})
